import GameModel from "../model/GameModel";
import InitState from "./InitState";
import IdleState from "./IdleState";
import RequestRollingState from "./RequestRollingState";
import StopRollingState from "./StopRollingState";
import ShowWinningsState from "./ShowWinningsState";
import ShowBigWinState from "./ShowBigWinState";
import FreeSpinsInState from "./FreeSpinsInState";
import FreeSpinsOutState from "./FreeSpinsOutState";
import SplashScreenState from "./SplashScreenState";
import GameSettings from "Base/settings/GameSettings";
import MinimalRollingState from "./MinimalRollingState";

export const StatesConfig = [
    { name: 'initState', class: InitState, transitions: [
            { to: 'splashScreenState', condition: function () {
                    return GameSettings.introScreen;
                }
            },
            /*{ to: 'showWinningsState', condition: function () {
                    return (GameModel.winnings && GameModel.winnings.lines);
                }
            },*/
            { to: 'idleState', condition: function () {
                    return true;
                }
            }
     ], entry: true},
    { name: 'splashScreenState', class: SplashScreenState, transitions: [
            /*{ to: 'showWinningsState', condition: function () {
                    return (GameModel.winnings && GameModel.winnings.lines);
                }
            },*/
            { to: 'idleState', condition: function () {
                    return true;
                }
            }
    ]},
    { name: 'idleState', class: IdleState, transitions: [
            { to: 'requestRollingState', condition: function () {
                    return GameModel.checkStartSpin();
                }
            }
    ]},
    { name: 'requestRollingState', class: RequestRollingState, transitions: [
            { to: 'minimalRollingState', condition: function () {
                    return true;
                }
            }
    ]},
    { name: 'minimalRollingState', class: MinimalRollingState, transitions: [
            { to: 'stopRollingState', condition: function () {
                    return true;
                }
            }
    ]},
    { name: 'stopRollingState', class: StopRollingState, transitions: [
            { to: 'showBigWinState', condition: function () {
                    return GameModel.totalWin >= GameModel.totalBet * 15;
                }
            },
            { to: 'showWinningsState', condition: function () {
                    return (GameModel.winnings && (GameModel.winnings.lines || GameModel.winnings.scatters));
                }
            },
            { to: 'freeSpinsInState', condition: function () {
                    return GameModel.freeSpins && GameModel.freeSpins.total > 0 && GameModel.freeSpins.total === GameModel.freeSpins.left;
                }
            },
            { to: 'freeSpinsOutState', condition: function () {
                    return GameModel.freeSpins && GameModel.freeSpins.total > 0 && GameModel.freeSpins.left === 0;
                }
            },
            { to: 'idleState', condition: function () {
                    return true;
                }
            }
    ]},
    { name: 'showWinningsState', class: ShowWinningsState, transitions: [
            /*{ to: 'showBigWinState', condition: function () {
                    return GameModel.totalWin >= GameModel.totalBet * 15;
                }
            },*/
            { to: 'freeSpinsInState', condition: function () {
                    return GameModel.freeSpins && GameModel.freeSpins.total > 0 && GameModel.freeSpins.total === GameModel.freeSpins.left;
                }
            },
            { to: 'freeSpinsOutState', condition: function () {
                    return GameModel.freeSpins && GameModel.freeSpins.total > 0 && GameModel.freeSpins.left === 0;
                }
            },
            { to: 'idleState', condition: function () {
                    return true;
                }
            }
    ]},
    { name: 'showBigWinState', class: ShowBigWinState, transitions: [
            { to: 'showWinningsState', condition: function () {
                    return (GameModel.winnings && (GameModel.winnings.lines || GameModel.winnings.scatters));
                }
            },
            /*{ to: 'freeSpinsInState', condition: function () {
                    return GameModel.freeSpins && GameModel.freeSpins.total > 0 && GameModel.freeSpins.total === GameModel.freeSpins.left;
                }
            },*/
            /*{ to: 'freeSpinsOutState', condition: function () {
                    return GameModel.freeSpins && GameModel.freeSpins.total > 0 && GameModel.freeSpins.left === 0;
                }
            },*/
            { to: 'idleState', condition: function () {
                    return true;
                }
            }
    ]},
    { name: 'freeSpinsInState', class: FreeSpinsInState, transitions: [
            { to: 'idleState', condition: function () {
                    return true;
                }
            }
     ]},
    { name: 'freeSpinsOutState', class: FreeSpinsOutState, transitions: [
            /*{ to: 'showBigWinState', condition: function () {
                    return GameModel.freeSpins && GameModel.freeSpins.totalWin >= GameModel.totalBet * 15;
                }
            },*/
            { to: 'idleState', condition: function () {
                    return true;
                }
            }
    ]},
];
